import { defineComponent as _defineComponent } from 'vue'
import marketIntellegence from '@/assets/icons/market-intellegence.png'
import paymentAndFinancing from '@/assets/icons/payment-and-financing.png'
import taxCompliance from '@/assets/icons/tax-and-compliance.png'

import coviaLogo from '@/assets/icons/covia.svg'
import credorLogo from '@/assets/icons/credor.svg'
import onlinePajakLogo from '@/assets/icons/onlinePajak.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'BenefitSection',
  setup(__props) {


const sideDescription = [
	{
		type: 'tax-and-compliance',
		powered_by: 'OnlinePajak',
		image: taxCompliance,
		powered_by_logo: onlinePajakLogo
	},
	{
		type: 'cash-and-financing',
		powered_by: 'Credor',
		image: paymentAndFinancing,
		powered_by_logo: credorLogo
	},
	{
		type: 'market-and-sourcing',
		powered_by: 'Covia',
		image: marketIntellegence,
		powered_by_logo: coviaLogo
	}
]

return { __sfc: true,sideDescription }
}

})